import { fill } from '../../utils/copy';
import type { Heading } from '../../core/types/pages';
type Props = {
  heading: Heading;
  /** Accent op een eigen regel in plaats van erachter. */
  accentBlock?: boolean;
  accentClassName?: string;
};

/** Rendert een beheerbare kop: gewone tekst plus optioneel een cursief accent. */
export function HeadingText({
  heading,
  accentBlock = false,
  accentClassName = 'text-clay'
}: Props) {
  return <>
      {fill(heading.text)}
      {heading.accent && <span className={`italic ${accentClassName} ${accentBlock ? 'block' : ''}`} data-id="element-8922" data-mp="317vmao8omso0">
          {accentBlock ? '' : ' '}
          {fill(heading.accent)}
        </span>}
    </>;
}